<template>
  <div class="login-container">
    <div class="left">
      <img src="../../assets/image/login.png" alt/>
    </div>
    <div class="right">
      <!-- label-width="50px" -->

      <el-form class="login-form" label-position="left" :rules="loginRules" ref="loginForm" :model="loginForm">
        <div class="title-container">
          <h3 class="title"></h3>
        </div>

        <el-form-item prop="username">

          <el-input class="username el-input" clearable v-model="loginForm.username" placeholder="请输入账号"
                    @keyup.enter.native="submitForm('loginForm')" auto-complete="off"/>
        </el-form-item>

        <el-form-item prop="password">

          <el-input :key="passwordType" v-model="loginForm.password" :type="passwordType" class="username el-input"
                    placeholder="请输入密码" auto-complete="off" @keyup.enter.native="submitForm('loginForm')"/>
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"/>
          </span>
        </el-form-item>

        <el-form-item prop="validateCode">

          <div class="yzm">
            <el-input maxlength="4" v-model="loginForm.validateCode" @keyup.enter.native="submitForm('loginForm')"
                      class placeholder="验证码" blur></el-input>
            <div class="img" @click="refreshCode">
              <!-- <img :src='yzmdata.code'  alt=""> -->
              <yzmcode :identifyCode="identifyCode"></yzmcode>
            </div>
          </div>
        </el-form-item>

        <el-button :loading="loading" type="primary" class="logins" @click="submitForm('loginForm')">登录</el-button>

        <!-- <div class="tips">
          <span style="margin-right:20px;">username: admin</span>
          <span>password: any</span>
        </div>-->
      </el-form>
    </div>
  </div>
</template>

<script>
function Base64() {

  // private property
  var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  // public method for encoding
  this.encode = function (input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = _utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output +
        _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
        _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
    }
    return output;
  }

  // public method for decoding
  this.decode = function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (i < input.length) {
      enc1 = _keyStr.indexOf(input.charAt(i++));
      enc2 = _keyStr.indexOf(input.charAt(i++));
      enc3 = _keyStr.indexOf(input.charAt(i++));
      enc4 = _keyStr.indexOf(input.charAt(i++));
      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = _utf8_decode(output);
    return output;
  }

  // private method for UTF-8 encoding
  var _utf8_encode = function (string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }
    return utftext;
  }

  // private method for UTF-8 decoding
  var _utf8_decode = function (utftext) {
    var string = "";
    var i = 0;
    var c = c1 = c2 = 0;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }
    }
    return string;
  }
}

import {isLoginName, validUsername} from "@/utils/validate";
// import { isLoginName } from '@/util/validate'
import {getAuthCode, loginByCode} from "@/api/api";
import yzmcode from "../template/code";
import {Loading} from 'element-ui';

export default {
  name: "Login",
  components: {
    yzmcode
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error("Please enter the correct user name"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("The password can not be less than 6 digits"));
      } else {
        callback();
      }
    };
    // 验证码
    const validateCode = (rule, value, callback) => {
      console.log("执行", value, this.identifyCode);
      if (this.identifyCode !== value) {
        this.loginForm.validateCode = "";
        this.refreshCode();
        callback(new Error("请输入正确的验证码"));
      } else {
        console.log("验证码正确");
        callback();
      }
    };
    return {
      identifyCodes: "1234567890",
      identifyCode: "",
      // 登录信息
      loginForm: {
        username: "",
        password: "",
        validateCode: ""
      },
      yzmdata: {
        code: 0
      },
      // 验证参数
      loginRules: {
        username: [{
          required: true,
          trigger: "blur",
          message: "请输入用户名"
        },
          {
            min: 1,
            max: 20,
            message: "长度在1-200字符之间",
            trigger: "blur"
          },
          {
            validator: isLoginName,
            trigger: "blur"
          }
        ],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        },
          {
            min: 1,
            max: 16,
            message: "长度在1-100字符之间",
            trigger: "blur"
          }
        ],
        validateCode: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        },
          {
            validator: validateCode,
            trigger: "blur"
          }
        ]
      },
      loading: false,
      passwordType: "password",
      redirect: undefined
    };
  },
  created() {
    this.refreshCode();
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
        if (route.query.id) {
          this.loginByCodeFn(route.query.id);
        }
      },
      immediate: true
    },
    identifyCode(v) {
      this.isDebugLogin && (this.loginForm.code = v);
    }
  },
  methods: {
    async loginByCodeFn(base64Code) {
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "自动登录中..."
      });
      try {
        const code = decodeURI(atob(base64Code))
        const res = await loginByCode({
          code
        })
        if (res.data && res.data.code === 0) {
          await this.$store.dispatch("user/loginByCode", res)
          this.$router.replace("/");
        } else {
          const message = (res.data && res.data.message) || "请求错误"
          this.$message.error(message)
        }
        loadingInstance.close();
      } catch (error) {
        this.$message.error("供应商编码错误")
        loadingInstance.close();
      }
    },
    // 显示密码
    showPassword() {
      this.passwordType === "" ?
        (this.passwordType = "password") :
        (this.passwordType = "");
    },

    // 提交验证码
    submitForm(formName) {
      console.log(formName);
      this.$refs[formName].validate(async valid => {
        console.log("登录", valid);
        if (valid) {
          this.loading = true;
          // 数据放到   vuex
          var obj = {
            username: this.loginForm.username,
            password: this.loginForm.password,
            validateCode: this.loginForm.validateCode
          }
          var base = new Base64();
          let num = Math.floor((Math.random() * 10) + 10);
          obj.password += num
          var result = base.encode(obj.password);
          obj.password = result;
          this.$store.dispatch("user/login", obj).then(res => {
            console.log(res);
            if (res.code == 0) {
              this.$message({
                message: "登录成功",
                type: "success"
              });
              this.$router.replace("/");
            } else {
              this.$message({
                message: res.message,
                type: "warning"
              });
            }
          });
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        } else {
          return false;
        }
      });
    },
    // 刷新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
      //  this.loginForm.validateCode = this.identifyCode
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
          ];
      }
    },
    // 获取验证码
    getcode() {
      console.log("获取验证码");
      this.yzmdata.code = `http://122.51.183.123/v/v1/account/loginValidateCode?a=${Math.random() *
      10000}`;
      getAuthCode();
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    // 获取cookie
    getCookie2(name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割 //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    }
  }
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

.logins {
  display: flex;
  justify-content: center;
  // width: 589px;
  width: 100%;
  height: 55px;
  font-size: 18px;
  margin-bottom: 30px;
}

/* reset element-ui css */
.login-container {
  .yzm {
    height: 50px !important;
    display: flex;

    .el-input {
      width: 60%;
    }

    color: #3333;

    input {
      height: 50px !important;
      color: #333 !important;
      width: 70% !important;
      // border: 1px solid red;
    }

    .img {
      width: 40%;
      background-color: #fff;
      height: 50px !important;
    }
  }

  .el-form-item__error {
    font-size: 16px;
  }

  .el-input {
    display: inline-block;
    height: 50px !important;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #666;
      box-sizing: border-box;
      height: 50px;
      font-size: 18px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  display: flex;
  min-height: 100%;
  width: 100%;
  // background-color: $bg;
  overflow: hidden;

  .left {
    width: 50%;
    height: 100vh;
    background-color: #1574d8;

    img {
      width: 100%;
    }
  }

  .right {
    width: 50%;
    background-color: #fff;

    .username {
      // width: 140px;
      // height: 37px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 50px;
      // color: rgba(51, 51, 51, 1);
      opacity: 1;
    }

    .el-input {
      height: 50px;
    }

    .el-form-item__content {
      height: 50px;
      line-height: 50px;

      .el-input__inner {
        width: 100%;
        height: 50px;
        background-color: #fff !important;
      }
    }

    .el-input input {
      height: 50px !important;
      line-height: 50px !important;
    }
  }

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 150px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
</style>
